
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import NewDateIntervalInput from 'component/DateIntervalInput/NewDateIntevalInput'
import RegionBranchMultipleSelect from 'component/branch/RegionBranchMultipleSelectNew'
import Select from 'component/Select/Select'
import { isEmpty } from 'utils/validations'
import CloseIconSVG from 'component/svgComponents/close'
import moment from 'moment'

const ALL_OPTION = {
  label: 'Todos',
  value: "Todos"
}

const SideFilterParams = ({
  sideFilterVisible,
  submit,
  translate,
  closeFilters,
  user,
  initialFilters
}) => {
  const initialState = {
    idBranches: [],
    status: null,
    dsCard: ALL_OPTION,
    dtStart: null,
    dtEnd: null,
  };

  const [formData, setFormData] = useState(initialState);
  const [allBranches, setAllBranches] = useState([]);
  const [, setPreviousFormData] = useState(initialState);
  const [dateResetKey, setDateResetKey] = useState(0);

  const getStatusOptions = () => {
    const options = [
      {
        label: translate('parameters.status.all'),
        value: null,
      },
      {
        label: translate('parameters.status.active'),
        value: 0,
      },
      {
        label: translate('parameters.status.inactive'),
        value: 1,
      },
      {
        label: translate('parameters.status.expired'),
        value: 2,
      }
    ]
    return options
  }

  useEffect(() => {
    if (initialFilters && sideFilterVisible && allBranches.length > 0) {
      let selectedBranches = [];
      const branchIdsToRestore = initialFilters.idBranches || initialFilters.idBranchesCodes || [];
      if (branchIdsToRestore.length > 0) {
        selectedBranches = branchIdsToRestore.map(branchId => {
          let foundBranch = allBranches.find(branch =>
            branch.value === branchId || branch.idBranch === branchId
          );
          if (!foundBranch) {
            foundBranch = allBranches.find(branch => {
              if (branch.idBranches && Array.isArray(branch.idBranches)) {
                return branch.idBranches.includes(branchId) && branch.idBranches.length === 1;
              }
              return false;
            });
          }
          if (!foundBranch) {
            const branchNameMapping = {
              '0004': '0004 - LOJA CONTAGEM',
              '0013': '0013 - LOJA BRASILIA SUL',
              '0018': '0018 - LOJA GOIANIA',
              '0020': '0020 - LOJA BH SUL',
              '0023': '0023 - LOJA TAGUATINGA',
              '0028': '0028 - LOJA BRASILIA NORTE'
            };
            const branchName = branchNameMapping[branchId] || `Loja ${branchId}`;
            foundBranch = {
              idBranches: [branchId],
              label: branchName,
              value: branchId,
              idBranch: branchId
            };
          }
          return foundBranch;
        });
      } else {
        selectedBranches = allBranches.filter((o) => o.visible !== false);
      }
      const statusOptions = getStatusOptions();
      const selectedStatus = initialFilters.status !== null && initialFilters.status !== undefined
        ? statusOptions.find(option => option.value === initialFilters.status)
        : statusOptions[0];
      const selectedCard = initialFilters.dsCard && initialFilters.dsCard !== "Todos"
        ? { label: initialFilters.dsCard, value: initialFilters.dsCard }
        : ALL_OPTION;
      const restoredData = {
        idBranches: selectedBranches,
        idBranchesCodes: initialFilters.idBranches || [],
        status: selectedStatus ? selectedStatus.value : null,
        dsCard: selectedCard || ALL_OPTION,
        dtStart: initialFilters.dtStart,
        dtEnd: initialFilters.dtEnd,
      };
      setFormData(restoredData);
      setPreviousFormData(restoredData);
    }
  }, [initialFilters, sideFilterVisible, allBranches]);

  useEffect(() => {
    if (sideFilterVisible && formData.idBranches.length === 0 && allBranches.length > 0) {
      const allVisibleOptions = allBranches.filter((o) => o.visible !== false);
      handleFormChange('idBranches', allVisibleOptions);
    }
  }, [sideFilterVisible, allBranches]);

  const handleDate = (dates) => {
    if (!dates || !dates[0] || !dates[1]) {
      setFormData((prev) => ({
        ...prev,
        dtStart: null,
        dtEnd: null,
      }));
      return;
    }
    const newFormData = { ...formData }
    const dtStart = moment(dates[0]).format("YYYY-MM-DD")
    const dtEnd = moment(dates[1]).format("YYYY-MM-DD")

    newFormData.dtStart = dtStart
    newFormData.dtEnd = dtEnd

    setFormData(newFormData)
  }

  const resetFilter = () => {
    const resetData = {
      ...initialState,
      dsCard: ALL_OPTION
    }
    setFormData(resetData)
    setPreviousFormData(resetData)
    setDateResetKey(prev => prev + 1)
    setTimeout(() => {
      if (allBranches.length > 0) {
        const allVisibleOptions = allBranches.filter((o) => o.visible !== false)
        handleFormChange('idBranches', allVisibleOptions)
      }
    }, 0)
  }

  const hasAnyFilterApplied = () => {
    const hasBranches = formData.idBranches && formData.idBranches.length > 0;
    const hasCard = formData.dsCard && formData.dsCard.value && formData.dsCard.value !== "Todos";
    const hasStatus = formData.status !== null && formData.status !== undefined;
    const hasDateRange = formData.dtStart && formData.dtEnd;
    
    return hasBranches || hasCard || hasStatus || hasDateRange;
  };

  const submitValues = () => {
    const transformedData = {
      idBranches: formData.idBranchesCodes,
      ...(formData.status != null && { status: Number(formData.status) }),
      dtStart: formData.dtStart || null,
      dtEnd: formData.dtEnd || null,
    };
    if (formData.dsCard) {
      transformedData.dsCard = formData.dsCard.value || formData.dsCard
    }
    setPreviousFormData(formData)
    submit(transformedData)
    closeFilters()
  }

  const handleFormChange = (field, selectedValue) => {
    if (field === 'idBranches') {
      const branchCodes = selectedValue.flatMap((item) => {
        if (item.idBranches) return item.idBranches
        if (item.isBranch) return item.value
        return []
      })
      setFormData((prev) => ({
        ...prev,
        [field]: selectedValue,
        [`${field}Codes`]: branchCodes,
      }))
    } else if (field === 'status') {
      setFormData((prev) => ({
        ...prev,
        status: selectedValue === undefined ? null : selectedValue,
      }))
    } else if (field === 'dsCard') {
      setFormData((prev) => ({
        ...prev,
        dsCard: selectedValue === undefined ? ALL_OPTION : selectedValue,
      }))
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: selectedValue,
      }))
    }
  }

  // TODO: Function commented for future use
  // const getCardOptions = () => {
  //   const options = [
  //     {
  //       label: translate('parameters.card.all'),
  //       value: "Todos",
  //     },
  //     {
  //       label: translate('parameters.card.celebre'),
  //       value: 'Celebre',
  //     },
  //     {
  //       label: translate('parameters.card.others'),
  //       value: 'Outros',
  //     },
  //   ]

  //   return options
  // }

  return (
    <>
      <div style={{ display: sideFilterVisible ? 'shown' : 'none' }} className='bg-filter' />
      <div style={{ display: sideFilterVisible ? '' : 'none' }} className='right-filter-container'>
        <CloseIconSVG className="right-filter-svg" onClick={() => closeFilters()} />
        <h3 className='margin-bottom-triple'>
          <strong>{translate('mobile.filter')}</strong>
        </h3>

        <div>
          <RegionBranchMultipleSelect
            required
            name='idBranches'
            label={translate('irc.store')}
            placeholder={translate('select.one.store')}
            user={user}
            translate={translate}
            onChange={(e) => handleFormChange('idBranches', e.target.value)}
            value={formData.idBranches}
            getAllBranchs={setAllBranches}
          />
        </div>

        <div>
          <Select
            fill
            required
            label={translate('status')}
            placeholder={translate('parameters.status.all')}
            options={getStatusOptions()}
            onChange={(e) => handleFormChange('status', e?.value ?? null)}
            value={getStatusOptions().find(({ value }) => value === formData.status)}
          />
        </div>

        {/* TODO: DS CARTÃO select commented for future use */}
        {/* <div>
          <Select
            fill
            required
            label={translate('config.pricebannerConfig.tableHeader.dsCard')}
            placeholder={"Todos"}
            options={getCardOptions()}
            onChange={(e) => handleFormChange('dsCard', e.value)}
            value={getCardOptions().find(({ value }) => value === formData.dsCard)}
            validateValue={(v) => (v?.value || '').length > 0}
          />
        </div> */}

        <NewDateIntervalInput
          key={`date-input-${dateResetKey}`}
          t={translate}
          user={false}
          reset={isEmpty(formData.dtStart)}
          label={translate('price.banner.period')}
          required
          initialValue={formData.dtStart && formData.dtEnd ? [moment(formData.dtStart), moment(formData.dtEnd)] : null}
          onChange={(dates) => {
            handleDate(dates)
          }}
          maxLimitDay={false}
        />

        <div style={{ marginTop: '30px' }} className='flex flex-row gap-filters'>
          <button
            className={`btn btn-danger-outline full-w`}
            onClick={resetFilter}>
            {translate('suggestions.cleanFilters')}
          </button>

          <button
            className={`btn btn-primary full-w`}
            disabled={!hasAnyFilterApplied()}
            onClick={submitValues}
          >
            {translate('commonReport.filter')}
          </button>
        </div>
      </div>
    </>

  )
}

SideFilterParams.propTypes = {
  sideFilterVisible: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  resetFilter: PropTypes.func.isRequired,
  closeFilters: PropTypes.func.isRequired,
  user: PropTypes.object,
  initialFilters: PropTypes.object
}

export default SideFilterParams

export { SideFilterParams }
